import React, { PureComponent } from 'react';
//import PropTypes from 'prop-types';

class TdGrid extends PureComponent {
    render() {
        const { odd } = this.props;
        return (
            <div 
                align={this.props.align ? this.props.align : 'center'} 
                className="panel panel-default" style={{
                padding: 10,
                borderRadius: 0,
                width: '100%',
                borderWidth: 0,
                borderBottomWidth: 1,
                marginBottom: 0,
                backgroundColor: odd ? '#f1f1f1' : '#fff'
            }}>
                {this.props.children}
            </div>
        );
    }
}

TdGrid.propTypes = {

};

export default TdGrid;